import { get, post, put, del } from "../client";

// WhatsApp business-bot add-on — dashboard (businessAuth) service wrappers.
// Backend contract: src/routes/v1/waBot.route.js (Backend, feature/hyp-phase2).
// req.business.sub = the business _id (derived from the token, not sent).
export default {
  // Add-on lifecycle (paid ₪109/mo, idempotent activate).
  activate_addon: async () => post("/wa-bot/addon", {}),
  remove_addon: async () => del("/wa-bot/addon"),

  // Connect / QR — proxy the WhatsApp platform.
  // connect may 502 locally when the platform partner creds are missing.
  connect: async (data = {}) => post("/wa-bot/connect", data),
  get_qr: async () => get("/wa-bot/qr"), // { state: qr|starting|working, qrBase64? }

  // Status — add-on + connection + bot state.
  // { addOnActive, price, subscribedPrice, trialEndsAt, trialDays, grantedFree,
  //   connected, whatsappState, connectedPhone,
  //   bot:{ enabled, activeHours, activeNow, ai }, newClientPolicy,
  //   existingOnlyMessage, aiSettings }
  // `aiSettings` is the structured מזכירת-AI form, stored verbatim — the source
  // of truth the AI-receptionist screen rehydrates from.
  get_status: async () => get("/wa-bot/status"),

  // Live WhatsApp-session probe. get_status() reports the last state we
  // recorded; this asks the session itself, so a line that died quietly is not
  // still rendered as "connected".
  // { live, connected, wahaState, reachable, checkedAt }
  health: async () => get("/wa-bot/health"),

  // Usage/performance for the last `days` (server default + cap: 30 / 90).
  // { days, conversations, booked, cancelled, rescheduled, leads } — plan
  // allowance fields ride along only once the backend that emits them is
  // deployed, so every reader must treat them as optional.
  stats: async (days) =>
    get(days ? `/wa-bot/stats?days=${days}` : "/wa-bot/stats"),

  // Settings — ALWAYS send all ai fields together (§6.5) so none is dropped.
  // The structured form goes as `aiSettings`; the server compiles it into the
  // agent directives (aiSettingsCompiler.js) and rides them on ai.instructions.
  save_settings: async (data) => put("/wa-bot/settings", data),

  // Mint a short-lived (30-min) public QR-scan page for another device.
  share_link: async () => post("/wa-bot/share-link", {}),
};
